import { useAppDispatch } from 'app/store/configureStore';
import { useCallback } from 'react';
import { markNotificationAsOldAction } from 'app/store/Notifications/slice';

export const useMarkNotificationAsOld = () => {
  const dispatch = useAppDispatch();
  const markNotificationAsOld = useCallback(
    (guid: string) => dispatch(markNotificationAsOldAction(guid)),
    [dispatch]
  );
  return { markNotificationAsOld };
};
